import { Grid, Icon, Typography } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';
import VerticalCenter from '../vertical-center/vertical-center';
import { styles } from './dialog-title-styles';

interface IDialogTitleProps {
  title: string;
  rightIcon?: (props: SvgIconProps) => JSX.Element;
}

const DialogTitle: React.FC<IDialogTitleProps> = (props: IDialogTitleProps): JSX.Element => {
  const classes = styles();

  return (
    <Grid container className={classes.titleContainer}>
      <Grid item xs={6}>
        <VerticalCenter justifyContent='flex-start'>
          <Typography className={classes.title}>{props.title}</Typography>
        </VerticalCenter>
      </Grid>
      <Grid item xs={6}>
        <VerticalCenter justifyContent='flex-end'>
          <Grid item>
            <VerticalCenter>
              <Icon className={classes.icon}>
                {props.rightIcon !== undefined ? (
                  <props.rightIcon className={classes.iconElement} />
                ) : null}
              </Icon>
            </VerticalCenter>
          </Grid>
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

export default DialogTitle;
